/* import __COLOCATED_TEMPLATE__ from './upsell.hbs'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import productNameTranslationKey from '@banking/ui/utils/checking/product-name-translation-key';
import { Country } from '@square/dashboard-protos/models/squareup/common/countries';
import { ProductName } from '@banking/ui/models/checking/product-positioning';
import { inject as service } from '@ember/service';
import { GetKybVerificationDataRequest } from '@square/dashboard-protos/models/squareup/bbqualifier/verification_data_service';
import { VerificationStatus } from '@square/dashboard-protos/models/squareup/bbqualifier/verification_service';
import { getOnboardingUpsellImageUrl } from '@banking/ui/utils/checking-image-urls';
let Upsell = (_class = class Upsell extends Component {
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "assetMap", _descriptor, this);
    _initializerDefineProperty(this, "bbQualifierApi", _descriptor2, this);
    _initializerDefineProperty(this, "userInfo", _descriptor3, this);
    _initializerDefineProperty(this, "intl", _descriptor4, this);
    _initializerDefineProperty(this, "sentry", _descriptor5, this);
    _initializerDefineProperty(this, "storedBalanceProductPositioning", _descriptor6, this);
    _defineProperty(this, "productName", void 0);
    _initializerDefineProperty(this, "isApprovedForChecking", _descriptor7, this);
    _initializerDefineProperty(this, "isLoading", _descriptor8, this);
    try {
      const country = Country[this.userInfo.countryCode];
      if (!(country === Country.US || country === Country.CA || country === Country.GB)) {
        throw new Error(`Country "${country}" is not supported within stored balance routes.`);
      }
      if (this.storedBalanceProductPositioning.productName === ProductName.None) {
        throw new Error('ProductName.None is not supported within stored balance routes.');
      }
      this.productName = this.storedBalanceProductPositioning.productName;
    } catch (error) {
      this.sentry.captureException(error);
      throw error;
    }
    this.setIsApprovedForChecking();
  }
  async setIsApprovedForChecking() {
    try {
      const kybVerificationData = await this.bbQualifierApi.getKybVerificationData(GetKybVerificationDataRequest.create({
        unitToken: this.args.unitToken
      }));
      this.isApprovedForChecking = kybVerificationData.kybStatus === VerificationStatus.PASSED;
    } catch {
      throw new Error('getKybVerificationData failed for checking upsell');
    } finally {
      this.isLoading = false;
    }
  }
  get headline() {
    return this.intl.t(productNameTranslationKey(this.productName, 'banking.checking.upsell.headline'));
  }
  get imageSrc() {
    const countryCode = this.userInfo.countryCode;
    const imgSrc = getOnboardingUpsellImageUrl(countryCode);
    return this.assetMap.resolve(imgSrc);
  }
  get imageAlt() {
    return this.intl.t(productNameTranslationKey(this.productName, 'banking.checking.upsell.imageAlt'));
  }
  get title() {
    return this.intl.t(productNameTranslationKey(this.productName, 'banking.checking.upsell.title'), {
      htmlSafe: true
    });
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "assetMap", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "bbQualifierApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "sentry", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "storedBalanceProductPositioning", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "isApprovedForChecking", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "isLoading", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _class);
export { Upsell as default };